module.exports = __webpack_public_path__ + "static/img/104134.ae5030a3.png";